import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createMarketersBalanceReportSlice = (set, get) => ({
    balance: {
        loading: false,
        data: [],
    },
    getMarketerBalance: async (userName) => {

        // const token = get().business.currentBusiness.token;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        if (!userName) { set(state => ({ balance: { loading: false, data: [] } })); return }
        set(state => ({ balance: { ...state.balance, loading: true } }));
        try {
            if (userName) {
                const resp = await axiosInstance({
                    method: "get",
                    baseURL: config.apiUrls(),
                    url: `/v1/business/user/${userName}/balance`,
                    headers: { token },
                });
                set(state => ({ balance: { loading: false, data: resp.data.Balances } }));
            }
        } catch (error) {
            // set(state => ({ balance: { ...state.balance, loading: false } }));
            set(state => ({ balance: { loading: false, data: [] } }));
        }
    }
});
